export default __webpack_public_path__ + "static/media/mozart2.0a735a6d.png";